import React from 'react';
import path from 'path';
import SideMenu from 'mrf/view/SideMenu';
import RouteMenu from './MenuRoute';
import UnderConstruction from './UnderConstruction';
import Flex from 'mrf/layout/Flex';
import usePrintMode from 'mrf/utils/usePrintMode';
import IF from './IF';
import RouteAuth from './user/RouteAuth';
import { SideMenuContainer } from 'mrf/styles/components/SideMenu.styles';

export default function SideMenuRouter({ match, menuList, indexComponent=UnderConstruction, width }) {
    const printMode = usePrintMode();

    return <Flex>
        <IF condition={!printMode}>
            <SideMenu match={match} list={menuList} width={width} />
        </IF>
        <SideMenuContainer>
            <RouteMenu match={match} indexComponent={indexComponent}>
                {menuList.map((menu, idx1) =>
                    menu.subMenu
                        ? menu.subMenu.map((item, idx2) => (
                            <RouteAuth
                                key={idx2}
                                path={path.join(match.url, item.path)}
                                component={item.component}
                                roleCodes={item?.roleCodes ?? menu?.roleCodes}
                            />)
                        ) : (
                            <RouteAuth
                                key={idx1}
                                path={path.join(match.url, menu.path)}
                                component={menu.component}
                                roleCodes={menu?.roleCodes}
                            />
                        )
                )}
            </RouteMenu>
        </SideMenuContainer>
    </Flex>
}
